
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";
import { ReferralFriend } from "@/hooks/useReferrals";

interface FriendCardProps {
  friend: ReferralFriend;
}

const FriendCard = ({ friend }: FriendCardProps) => {
  const fullName = [friend.firstName, friend.lastName]
    .filter(Boolean)
    .join(' ') || 'Anonymous User';
  
  const timeAgo = formatDistanceToNow(new Date(friend.joinedAt), { addSuffix: true });
  
  return (
    <div className="border border-gray-200 rounded-lg p-3 flex justify-between items-center">
      <div>
        <div className="font-medium text-[#4A607B]">{fullName}</div>
        <div className="text-xs text-[#718096]">Joined {timeAgo}</div>
      </div>
      <Badge 
        variant={friend.isPaid ? "default" : "outline"}
        className={friend.isPaid 
          ? "bg-green-500 hover:bg-green-500" 
          : "border-gray-300 text-gray-500"}
      >
        {friend.isPaid ? "Paid" : "Free"}
      </Badge>
    </div>
  );
};

export default FriendCard;
